import { RouteRecordRaw } from 'vue-router';
import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const menuRoutes: AppRouteRecordRaw[] = [
  {
    path: 'production-order',
    name: 'ProductionOrderForFactory',
    component: () => import('@/views/factory/productionOrder/index.vue'),
    meta: {
      title: '生产单',
      requiresAuth: true,
      activeMenu: 'ProductionOrderForFactory',
    },
  },
  {
    path: 'washing-label-template',
    name: 'WashingLabelTemplateForFactory',
    component: () => import('@/views/basis/washingLabelTemplate/index.vue'),
    meta: {
      title: '洗水唛模板',
      requiresAuth: true,
      sysConfig: true,
      sysConfigKey: 'miniProgramShowWashingMark',
    },
  },
  {
    path: 'production-order-detail',
    name: 'ProductionOrderDetailForFactory',
    component: () => import('@/views/factory/productionOrder/detail.vue'),
    props: (route: any) => ({ ordersSn: route.query.ordersSn }),
    meta: {
      hideInMenu: true,
      title: '生产单详情',
      requiresAuth: true,
    },
  },
  {
    path: 'supplier-bill',
    name: 'SupplierBillForFactory',
    component: () => import('@/views/factory/bill/index.vue'),
    meta: {
      title: '对账单',
      requiresAuth: true,
    },
  },
];

export const Factory: RouteRecordRaw = {
  path: '/factory',
  name: 'Factory',
  component: DEFAULT_LAYOUT,
  meta: {
    requiresAuth: false,
    title: '加工厂',
  },
  children: menuRoutes,
};

export default menuRoutes;
